<template>
  <article>
    <div class="dataForm">
      <div class="dataForm__item">
        <div class="dataForm__name">订单ID</div>
        <el-input v-model="detail.eoid" placeholder="" size="mini" class="dataForm__input" :disabled="true"></el-input>
      </div>
      <div class="dataForm__item mt-16">
        <div class="dataForm__name">用户ID</div>
        <el-input v-model="detail.euid" placeholder="" size="mini" class="dataForm__input" :disabled="true"></el-input>
      </div>
      <div class="dataForm__item mt-16">
        <div class="dataForm__name">用户昵称</div>
        <el-input v-model="detail.nickname" placeholder="" size="mini" class="dataForm__input" :disabled="true"></el-input>
      </div>
      <div class="dataForm__item mt-16">
        <div class="dataForm__name">跟单人</div>
        <el-select class="filter__input" size="mini" v-model="detail.opid">
          <el-option :label="item.nickname" :value="item.opid" v-for="(item, index) in operLists" :key="index"></el-option>
        </el-select>
      </div>
      <div class="dataForm__item mt-16">
        <div class="dataForm__name">订单号</div>
        <el-input v-model="detail.orderid" placeholder="" size="mini" class="dataForm__input" :disabled="detail.eoid"></el-input>
      </div>
      <div class="dataForm__item mt-16">
        <div class="dataForm__name">活动名称</div>
        <el-select placeholder="请选择" v-model="detail.etid" :disabled="detail.eoid">
          <el-option v-for="item in taskListss" :key="item.value" :label="item.title" class="dataForm__input"  :value="item.etid"> </el-option>
        </el-select>
      </div>
      <div class="dataForm__item mt-16">
        <div class="dataForm__name">购买类型</div>
        <el-radio-group v-model="detail.purchase">
          <div class="dib mr-20">
            <el-radio :label="0">需要返款</el-radio>
            <el-radio :label="1">直接折扣</el-radio>
            <el-radio :label="2">假单</el-radio>
            <el-radio :label="3">囤货</el-radio>
            <el-radio :label="4">固返</el-radio>
          </div>
        </el-radio-group>
      </div>
      <div class="dataForm__item mt-16">
        <div class="dataForm__name">底价折扣</div>
        <el-input v-model="detail.min_discount" placeholder="" size="mini" class="dataForm__input" :disabled="true">
          <template slot="append">%</template>
        </el-input>
      </div>
      <div class="dataForm__item mt-16">
        <div class="dataForm__name">折扣</div>
        <el-input v-model="detail.discount" placeholder="" size="mini" class="dataForm__input">
          <template slot="append">%</template>
        </el-input>
      </div>
      <div class="dataForm__item mt-16">
        <div class="dataForm__name">金额</div>
        <el-input v-model="detail.payment" placeholder="" size="mini" class="dataForm__input"></el-input>
      </div>
      <div class="dataForm__item mt-16">
        <div class="dataForm__name">拍收费</div>
        <el-input v-model="detail.agency_fees" placeholder="" size="mini" class="dataForm__input"></el-input>
      </div>
      <div class="dataForm__item mt-16">
        <div class="dataForm__name">发票奖励</div>
        <el-input v-model="detail.bonus" placeholder="" size="mini" class="dataForm__input"></el-input>
      </div>
      <div class="dataForm__item mt-20">
        <div class="dataForm__name ml40">报单截图</div>
        <div class="headimg-container relative" style="width:250px">
          <uploadHeadImage :url.sync="detail.payment_img" :itype="5"></uploadHeadImage>
        </div>
      </div>
      <div class="dataForm__item mt-20">
        <div class="dataForm__name ml40">完成截图</div>
        <div class="headimg-container relative" style="width:250px">
          <uploadHeadImage :url.sync="detail.finish_img" :itype="5"></uploadHeadImage>
        </div>
      </div>
      <div class="dataForm__item mt-16">
        <div class="dataForm__name">备注</div>
        <el-input v-model="detail.remark" placeholder="" size="mini" class="dataForm__input"></el-input>
      </div>
      <div class="dataForm__item mt-16">
        <div class="dataForm__name">日期</div>
        <el-date-picker v-model="detail.date" type="date" placeholder="选择日期"> </el-date-picker>
      </div>
      <div class="dataForm__item mt-16">
        <div class="dataForm__name">是否开发票</div>
        <el-radio-group v-model="detail.is_invoice">
          <div class="dib mr-20">
            <el-radio :label="0">否</el-radio>
            <el-radio :label="1">开</el-radio>
          </div>
        </el-radio-group>
      </div>
      <div class="dataForm__item mt-16" v-if="detail.eoid != 0">
        <div class="dataForm__name">状态</div>
        <el-radio-group v-model="detail.status">
          <div class="dib mr-20">
            <el-radio :label="0">报单</el-radio>
            <el-radio :label="1">跟单中</el-radio>
            <el-radio :label="2">完成订单</el-radio>
            <el-radio :label="5">失效</el-radio>
            <el-radio :label="6">拒绝</el-radio>
          </div>
        </el-radio-group>
      </div>
      <div class="dataForm__item mt-16">
        <div class="dataForm__name"></div>
        <button class="blue-large-btn" @click="earnOrderEdit">保存</button>
      </div>
    </div>
  </article>
</template>

<script>
import util from '../../../script/util'
import {taskLists, earnOrderDetail, earnOrderEdit, operLists} from '../../../api/api'
import uploadHeadImage from '../../../components/uploadImage.vue'
export default {
  name: 'earnOrderEdit',
  components: {
    uploadHeadImage
  },
  data () {
    return {
      detail: {
        eoid: 0,
        euid: 1,
        username: '',
        nickname: '报单专用',
        opid: 1,
        etid: '',
        purchase: 3,
        payment: '',
        min_discount: '',
        discount: '',
        orderid: '',
        agency_fees: 0,
        bonus: 0,
        is_invoice: 0,
        commission: '',
        payment_img: '',
        finish_img: '',
        remark: '',
        date: new Date(),
        status: 0
      },
      dialog: false,
      dateTime: '',
      taskListss: [],
      operLists: [],
      statusList: [
        {
          name: '正常',
          value: 1
        },
        {
          name: '停止',
          value: 0
        }
      ]
    }
  },
  methods: {
    changeTask () {
      this.taskListss.forEach((item) => {
        if (item.etid === this.detail.etid && this.detail.eoid === 0) {
          this.detail.min_discount = item.min_discount
        }
      })
    },
    getOperLists () {
      let params = {
        market: 3,
        l: 500,
        p: 1
      }
      operLists(params).then((res) => {
        let data = res.data || {c: -1}
        if (!data.c) {
          this.operLists = data.d.lists.map((item, index) => {
            return {
              nickname: item.nickname,
              opid: item.opid
            }
          })
        }
      })
    },
    getTaskLists () {
      let params = {
        market: 3,
        l: 500,
        p: 1
      }
      taskLists(params).then((res) => {
        let data = res.data || {c: -1}
        if (!data.c) {
          this.taskListss = data.d.lists.map((item, index) => {
            return {
              title: item.title,
              etid: item.etid,
              min_discount: item.min_discount
            }
          })
          this.changeetid()
        }
      })
    },
    earnOrderDetail () {
      let params = {
        eoid: this.detail.eoid
      }
      this.loading = true
      earnOrderDetail(params).then((res) => {
        let data = res.data || {c: -1}
        if (!data.c) {
          this.detail = data.d
          this.detail.date = new Date(this.detail.date * 1000)
        }
        this.loading = false
      })
    },
    earnOrderEdit () {
      let params = util.cloneObj(this.detail)
      params['date'] = parseInt(this.detail.date.getTime() / 1000)

      let content = ''

      if (params.discount < 0 || params.discount > 100) {
        content = '折扣不正确'
      }

      if (params.payment_img === '') {
        content = '请上传下单截图'
      }

      if (params.status === 2 && params.finish_img === '') {
        content = '请上传完成截图'
      }

      if (content) {
        this.$notify({
          title: '失败',
          message: content,
          type: 'error'
        })
        return
      }

      earnOrderEdit(params).then((res) => {
        let data = res.data || {c: -1}
        if (!data.c) {
          this.$notify({
            title: '成功',
            message: '保存成功',
            type: 'success'
          })
          this.$router.push('/earnOrder')
        } else {
          this.$notify({
            title: '失败',
            message: util.getErrorMsg(data.c),
            type: 'error'
          })
        }
      })
    }
  },
  watch: {
    'detail.etid': 'changeTask'
  },
  mounted () {
    this.detail.eoid = parseInt(this.$route.query.eoid || 0)
    if (this.detail.eoid) {
      this.earnOrderDetail()
    }

    this.getOperLists()
    this.getTaskLists()
  }
}
</script>

<style lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// src/page/module/earn/earnOrderEdit.vue